import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(10000);
const savedMinimalSchema = z.string().max(10000);
const schema = z.string().min(1).max(10000);
const savedSchema = z.string().min(1).max(10000);
const jsonSchema = z.string();
/**
 * 課題名(値オブジェクト)のメタデータ。
 *
 * 案件の課題名。 */
export const projectNameMeta = new ValueObjectMetaString(
  "ProjectName",
  "\u8AB2\u984C\u540D",
  messageId("lbl.\u8AB2\u984C\u540D"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
